import { ShipmentMethod } from "@domain/shipment/models/ShipmentMethod";
import { Stack, ButtonBase, Typography, useTheme } from "@mui/material";
import { TransportMethodIcon } from '@features/shipments/components/shared/TransportMethodIcon';

interface ShipmentMethodPreviewProps {
    method: ShipmentMethod;
    selected: boolean;
    onClick: () => void;
}


export const ShipmentMethodPreview = ({ method, selected, onClick }: ShipmentMethodPreviewProps) => {

    const theme = useTheme();

    return (
        <Stack
            key={method.id}
            component={ButtonBase}
            direction="row"
            gap={2}
            justifyContent="flex-start"
            onClick={onClick}
            sx={{
                border: 1,
                borderColor: selected ? 'primary.main' : 'divider',
                borderRadius: 1,
                p: 2,
                width: 200,
                backgroundColor: theme.palette.background.paper,
            }}
        >
            <TransportMethodIcon size={40} transportMethod={method.transportMethod} />
            <Stack direction="column" alignItems="flex-start" gap={0}>
                <Typography variant="subtitle2" color={selected ? 'primary.main' : 'text.primary'}>
                    {method.name || method.transportMethod.charAt(0).toUpperCase() + method.transportMethod.slice(1)}
                </Typography>
                <Typography variant="subtitle2" color={selected ? 'primary.main' : 'text.primary'}>
                    {method.duration} days
                </Typography>
            </Stack>
        </Stack>
    );
};